<template>
  <div>
    <a-row type="flex" class="area-header">
      <h1 class="title">Datasource Items</h1>
      <a-button type="primary" @click="handleEdit()">Create new</a-button>
    </a-row>

    <a-table
      :columns="columns"
      :dataSource="filteredItems"
      v-if="loadCompleted"
      :rowKey="record => record.id"
    >
      <div slot="name" slot-scope="record">{{ record.data[datasource.titleField] }}</div>
      <div slot="action" slot-scope="record">
        <div class="_d-flex">
          <a-button size="small" @click="handleEdit(record)">Edit</a-button>
          <a-button size="small" type="danger" @click="handleDelete(record)">Delete</a-button>
        </div>
      </div>
    </a-table>

    <a-modal
      title="Item Editor"
      v-model="isDialogVisible"
      @ok="currentItem = null;"
      @cancel="currentItem = null"
      :footer="null"
    >
      <app-edit-item-dialog
        v-if="currentItem"
        :datasource="datasource"
        :item="currentItem"
        @afterSave="afterItemSaved"
      ></app-edit-item-dialog>
    </a-modal>
  </div>
</template>

<script>
import AppEditItemDialog from "@/components/datasource/EditItem";
import { mapGetters } from "vuex";

export default {
  name: "Datasources",
  data() {
    return {
      datasource: null,
      isDialogVisible: false,
      loadCompleted: false,

      currentItem: null,

      search: null,

      columns: [
        {
          title: "Name",
          key: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "Action",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ]
    };
  },
  methods: {
    handleDelete(index, item) {
      this.$confirm(
        "Permanently delete datasource item. If this item is used in a booking, you will lose this reference in the booking. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.axios
            .delete(`/admin/datasource/${this.datasource.id}/item/${item.id}`)
            .then(() => {
              this.datasource.items.splice(index, 1);
              this.$message({
                message: "Item has been deleted.",
                type: "success"
              });
            });
        })
        .catch(() => {});
    },

    handleEdit(item = null) {
      this.currentItem = item || {
        data: {}
      };
      this.isDialogVisible = true;
    },

    afterItemSaved(itemData) {
      this.isDialogVisible = false;
      this.currentItem = null;
      if (!itemData.id) {
        this.datasource.items.push(itemData);
      }
    }
  },
  async created() {
    this.loadCompleted = false;
    this.$store.commit("SET_IS_FETCHING", true);
    const datasource = await this.$store.dispatch("datasource/fetchSingle", {
      id: this.$route.params.id,
      include: "items"
    });
    this.$set(this, "datasource", datasource);
    this.$store.commit("SET_IS_FETCHING", false);
    this.loadCompleted = true;
  },
  computed: {
    ...mapGetters("datasource", {
      datasourcesArray: "asArray"
    }),
    datasourceId() {
      return this.$route.params.id;
    },

    filteredItems() {
      if (!this.search || this.search == "") return this.datasource.items;

      const search = this.search.toLowerCase();

      return this.datasource.items.filter(i => {
        let found = false;

        this.datasource.fields.forEach(f => {
          if (
            i.data[f.id]
              .toString()
              .toLowerCase()
              .includes(search)
          ) {
            found = true;
          }
        });

        return found;
      });
    }
  },
  components: {
    AppEditItemDialog
  }
};
</script>
